import { useWhiteLabelingStyling } from '@verbit-ai/frontend-common'

const DEFAULT_TITLE = 'Real-Time Transcription'

export const AppHelmet = () => {
    const whiteLabelingStyling = useWhiteLabelingStyling()

    const title = whiteLabelingStyling ? `${whiteLabelingStyling.customerLabel} ${DEFAULT_TITLE}` : DEFAULT_TITLE

    const faviconUrl = whiteLabelingStyling?.logosTextless.light

    return (
        <>
            <title>{title}</title>
            {faviconUrl && <link rel="icon" href={faviconUrl} />}
        </>
    )
}
